const SUPPORTED_LANGUAGES = ["en", "es", "ca", "nl"];

function normalizeLanguage(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
}

export function getInitialLanguage() {
  // 1. Respect a language previously selected by the user.
  try {
    const savedLanguage = localStorage.getItem("language");
    const normalizedSaved = normalizeLanguage(savedLanguage);

    if (SUPPORTED_LANGUAGES.includes(normalizedSaved)) {
      return normalizedSaved;
    }
  } catch {
    // Continue with browser detection.
  }

  // 2. Detect Chrome/browser preferred languages.
  const browserLanguages =
    typeof navigator !== "undefined"
      ? navigator.languages?.length
        ? navigator.languages
        : [navigator.language]
      : [];

  for (const browserLanguage of browserLanguages) {
    const normalized = normalizeLanguage(browserLanguage);

    if (SUPPORTED_LANGUAGES.includes(normalized)) {
      return normalized;
    }
  }

  // 3. Default to English.
  return "en";
}
